






























































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { has } from 'lodash'
import { LayoutComponentVue } from '@/base'
import TheNavBar from '@/components/organisms/TheNavBar'
import ThePageTitle from '@/components/organisms/ThePageTitle'
import { ModalHelp } from '@/components/modals/ModalHelp'
import { footerType } from '@/types/footer.type'
import { appStore, felicaStore, icTagStore, pageStore } from '@/store'
import {
  PAGE_LOADING_END,
  PAGE_LOADING_START,
  APP_KEYDOWN,
  APP_KEYUP
} from '@/config/event'
import { DefaultIncludeCacheArray, AppKeydown, AppKeyup } from '@/types'
import { EventBus } from '@/plugins/event_bus'

@Component({
  middleware: ['authenticated', 'redirect'],
  components: {
    TheNavBar,
    ThePageTitle,
    ModalHelp
  }
})
export default class DefaultLayout extends LayoutComponentVue {
  @Ref()
  modalHelp!: ModalHelp

  loading = false

  observer: MutationObserver | undefined = undefined

  footerButtonTooltipVisible = false

  // 現時点ではICタグで使用することを前提としている
  connectMutationObserver(): void {
    // DOMクラスの変更自体を監視することは不可能だったので、追加と削除ができるオーバーレイを対象としている（ダイアログの表示数も条件に含めているので問題は無いはず）
    this.observer = new MutationObserver(mutations => {
      const modals: HTMLElement[] = Array.from(
        document.querySelectorAll('.v-dialog__content--active')
      )
      const alerts = modals.flatMap(modal =>
        Array.from(modal.querySelectorAll('#modal-alert'))
      )

      mutations.forEach(mutation => {
        if (
          Array.from(mutation.addedNodes).some(
            (node: any) => node.tagName && node.classList.contains('v-overlay')
          )
        ) {
          if (alerts.length === 1) {
            // アラートが開かれた時の処理
            this.onPageLoadingEnd()
          }
        }
        if (
          Array.from(mutation.removedNodes).some(
            (node: any) => node.tagName && node.classList.contains('v-overlay')
          )
        ) {
          if (alerts.length === 0) {
            // 全てのアラートを閉じた時の処理
            this.onPageLoadingStart()
          }
        }
      })
    })
    // appは確実に存在する
    this.observer.observe(document.getElementById('app') as HTMLElement, {
      childList: true,
      attributeFilter: ['class']
    })
  }

  disconnectMutationObserver(): void {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  get appClass() {
    return {
      'font-family-sans-serif': appStore.fontFamilyIsSansSerif,
      'font-family-serif': !appStore.fontFamilyIsSansSerif,
      'app-text-small': appStore.fontSizeTypeIsSmall,
      'app-text-normal': appStore.fontSizeTypeIsNormal,
      'app-text-large': appStore.fontSizeTypeIsLarge
    }
  }

  get pageTitle() {
    return pageStore.title
  }

  get leftFooterActions(): footerType.IAction[] {
    return pageStore.leftFooterActions
  }

  get rightFooterActions(): footerType.IAction[] {
    return pageStore.rightFooterActions
  }

  get isRouteTop(): boolean {
    return this.$route.name === 'index'
  }

  get mainStyle(): any {
    return this.isRouteTop
      ? {}
      : { 'margin-top': '40px', 'padding-bottom': '44px' }
  }

  get cachePageList(): any {
    return {
      include: DefaultIncludeCacheArray
    }
  }

  get processingIcTag(): boolean {
    return icTagStore.processing
  }

  get readingFelica(): boolean {
    return felicaStore.reading
  }

  @Watch('processingIcTag')
  onStartEndProcessingIcTag(newVal: boolean): void {
    if (newVal) {
      this.onPageLoadingStart()
      this.connectMutationObserver()
    } else {
      this.onPageLoadingEnd()
      this.disconnectMutationObserver()
    }
  }

  @Watch('readingFelica')
  onStartEndReadingFelica(newVal: boolean): void {
    if (newVal) {
      this.onPageLoadingStart()
    } else {
      this.onPageLoadingEnd()
    }
  }

  onClick(action: footerType.IAction): void {
    if (action.callback) {
      action.callback()
    }
    if (action.onClick) {
      action.onClick()
    }
  }

  onClickHelp(): void {
    this.modalHelp.open()
  }

  shouldDisableButton(action: footerType.IAction): boolean {
    if (has(action, 'disabled') && action.disabled) return action.disabled

    return false
  }

  created() {
    // this.debug('created()')
    this.$eventBus.on(PAGE_LOADING_START, this.onPageLoadingStart)
    this.$eventBus.on(PAGE_LOADING_END, this.onPageLoadingEnd)
  }

  mounted() {
    addEventListener('keydown', this.onKeydown)
    addEventListener('keyup', this.onKeyup)
  }

  destroyed() {
    // this.debug('destroyed()')
    this.$eventBus.off(PAGE_LOADING_START)
    this.$eventBus.off(PAGE_LOADING_END)
    removeEventListener('keydown', this.onKeydown)
    removeEventListener('keyup', this.onKeyup)
  }

  onKeydown(event: KeyboardEvent): void {
    EventBus.emit(APP_KEYDOWN, {
      key: event.key,
      ctrlKey: event.ctrlKey
    } as AppKeydown)

    if (event.key === 'Control') {
      this.footerButtonTooltipVisible = true
    }

    if (event.ctrlKey && /^\d$/.test(event.key)) {
      // chromeショートカットキー(Ctrl + 数字)によるタブ移動を防ぐ
      event.preventDefault()
    }
  }

  onKeyup(event: KeyboardEvent): void {
    EventBus.emit(APP_KEYUP, {
      key: event.key
    } as AppKeyup)

    this.footerButtonTooltipVisible = false
  }

  onPageLoadingStart() {
    this.loading = true
  }

  onPageLoadingEnd() {
    this.loading = false
  }

  footerClass(margin: number | undefined) {
    const mr = margin === undefined ? 'mr-2' : 'mr-' + margin
    return {
      [mr]: true
    }
  }

  readCancelFelica(): void {
    this.$felica.readCancel()
  }
}
